<p-card class="dashBoard">
  <div style="position:relative">
    @if (!ps.hasAnyRole(['ROLE_TRADER'])) {
<div  style="
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      opacity: 0.5;
      background-color: white;
      height: 100%;">
      </div>
    }
    <div class="title" [routerLink]="['/orders/order-blotter']">Blotter Summary</div>
    <br class="clear"/>
    @if (!(loadedActive&&loadedFilled)) {
      <div class='loading-spinner'></div>
    }
    @if (loadedActive&&loadedFilled) {
      <div style="padding-top:7px;">
        <div class="section">
          <div class="chart-container">
            <p-chart type="doughnut" [data]="chartData" [options]="options" width="128px" height="70px"></p-chart>
            <div class="center chart-overlay">
              <div class="count">{{data.activeBlotterTradesCount}}</div>
              <div class="label">Active Trades</div>
            </div>
          </div>
        </div>
        <irb-panel-button [label]="'Requires Attention'" (click)="showRequiresAttention()"><span class="count red">{{data.requiresAttentionCount}}</span></irb-panel-button>
        <irb-panel-button [label]="'Pending'" (click)="showPending()"><span class="count irb-amber">{{data.pendingCount}}</span></irb-panel-button>
        <irb-panel-button [label]="'Filled'" (click)="showFilled()"><span class="count irb-green">{{data.filledCount}}</span></irb-panel-button>
      </div>
    }
  </div>
</p-card>

